<template>
    <!-- 查询结果 -->
    <div class="searchResult">
      <TopNavigation class="topNavigation"></TopNavigation>
      <div>
        <div class="typeArea">
          <!-- 面包屑 -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>船东SPOT</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">查询结果</el-breadcrumb-item>
          </el-breadcrumb>

          <!-- 查询条件 -->
          <div class="conditiobn">
            <div class="title">
              <span>{{qygName }}</span>
              <img v-if="qygName || mdgName" src="@/assets/images/Group 98@2x(1).png" alt="" />
              <span>{{mdgName}}</span>
            </div>
            <div class="delivery-main">
            <div class="delivery-main-box youjiantou">
              <img src="@/assets/images/定位.png" alt="" />
              <div class="address">
                <div>起运港</div>
                <!-- @change="changeQyg" -->
                <el-select @change="changeQyg" v-model="searchQuery1JXYJ" clearable   filterable placeholder="请选择">
                  <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn+'-'+item.name_en"
                    :value="item.id"
                    v-show="item.display_range==0 || item.display_range==2"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="youbian youbianvv">
                <img src="../../assets/images/Group 92.png" />
              </div>
              <div class="switch jiantou">
                <div
                  :class="{ switchBackground: isSwitchQY(1) }"
                  @click="handleSwitchQY(1)"
                >
                  CY
                </div>
                <div
                  :class="{ switchBackground: isSwitchQY(2) }"
                  @click="handleSwitchQY(2)"
                >
                  SD
                </div>
              </div>
            </div>
  
            <div class="delivery-main-box">
              <img src="@/assets/images/定位.png" alt="" />
              <div class="address">
                <div>目的港</div>
                <el-select  
                @change="changeMdg" 
                v-model="searchQuery2JXYJ" 
                clearable  
                filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading"
                placeholder="请选择">
                   <!-- @tab-click="handleClick" -->
                  <el-tabs class="mudig" v-model="activeName">
                    <el-tab-pane
                      v-for="(item,index) in muDgList"
                      :key="index"
                      :label="item.route_name"
                      :name="item.route_name"
                    >
                      <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist">
                        <el-option
                          v-for="(at,adx) in it.port_arr"
                          :key="adx"
                          :label="at.port_name+'-'+at.name_en"
                          :value="at.port_id">
                        </el-option>
                      </el-option-group>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
              <div class="switch">
                <div
                  :class="{ switchBackground: isSwitchMD(1) }"
                  @click="handleSwitchMD(1)"
                >
                  CY
                </div>
                <div
                  :class="{ switchBackground: isSwitchMD(2) }"
                  @click="handleSwitchMD(2)"
                >
                  SD
                </div>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/箱型.png" alt="" />
              <div class="address">
                <div>箱型</div>
                <el-select 
                :multiple-limit="3"
                multiple
                collapse-tags
                class="xiangxing"
                clearable
                v-model="searchQuery3JXYJ" 
                placeholder="请选择">
                <el-option
                  v-for="item in boxTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/日期.png" alt="" />
              <div class="address">
                <div>开航起止日期</div>
                <el-date-picker
                  :picker-options="pickerOptions"
                  value-format='yyyy-MM-dd'
                  prefix-icon="null"
                  class="picker"
                  v-model="DateValue1"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>
  
            <div class="search" @click="searchList('CD')">
              <i class="el-icon-search"></i>
            </div>
          </div>
  
            <!-- 线条 -->
            <div class="line"></div>
  
            <!-- 筛选条件 -->
            <div class="condition">
              <img class="img" src="@/assets/images/shaixuan.png" alt="" />
              <span class="span">筛选</span>
              <!-- 排序方式 -->
              <el-cascader
                :disabled="is_vip==0"
                clearable 
                v-model="order_field_type"
                placeholder="排序方式"
                :options="options"
                @change="handleChange"
              ></el-cascader>
  
              <!-- 选择船公司 -->
            <el-select 
            :disabled="is_vip==0" 
            @change="handleChange"  
            v-model="shipping_company_code" 
            clearable 
            placeholder="请选择船公司"
            filterable
            :loading="loadingShip">
              <el-option
                v-for="item in shippingList"
                :key="item.value"
                :label="item.name_cn+'-'+item.name_en"
                :value="item.code">
              </el-option>
            </el-select>

              <!-- 选择中转、直达 -->
              <el-select :disabled="is_vip==0" v-model="is_transit" @change="handleChange" clearable placeholder="请选择中转/直达">
                <el-option label="直达" value="0"></el-option>
                <el-option label="中转" value="1"></el-option>
              </el-select>
  
              <!-- 选择箱源 -->
              <el-select :disabled="is_vip==0" v-model="box_source" @change="handleChange" clearable placeholder="请选择箱源">
                  <el-option label="全部" value=""></el-option>
                  <el-option
                  v-for="item in boxsourceList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 查询结果 -->
          <div v-if="total==0"  class="result" v-loading="loading">
            <el-empty :image-size="200" description="你查询的价格暂无数据，可以联系在线客服人工报价"></el-empty>
          </div>

          <div v-if="total>0 && is_vip!=0" class="result" v-loading="loading">
            <!-- 展示 -->
            <!-- 表头 -->
            <div class="table-header">
              <div class="biaotou">
                <div>船公司</div>
                <div class="qi">起运港</div>
                <div class="mu">目的港</div>
                <div
                v-for="(item,index) in boxTitleList"
                :key="index"
                class="gp"
                >
                    {{item}}
                </div>
              </div>
              <div>
                {{gengxinTime}}
              </div>
            </div>
           
            <div class="table-tbody">
                <div 
                class="neirong"
                v-for="(item,index) in resultsList"
                :key="index">
                    <div class="shang">
                        <div class="shang-le">
                          <div class="logo">
                              <img :src="item.shipowner.logo" alt="">
                          </div>
                          <div class="qiyun">
                              <div class="date"><span class="jiacu">ETD:</span>{{item.etd || '--'}}</div>
                              <div class="address">{{qygName}}</div>
                          </div>
                          <div class="dao">
                              <div class="tian">{{item.shipping_date}}天</div>
                              <img src="@/assets/images/Group 113@2x.png" alt="">
                              <div class="zhida">{{item.transitPort.length>0?'中转':'直达'}}</div>
                          </div>
                          <div class="qiyun">
                              <div class="date"><span class="jiacu">ETA:</span>{{item.eta || '--'}}</div>
                              <div class="address">{{mdgName}}</div>
                          </div>
                          <div class="qian">
                              <div>
                                  <span class="qian_tit">海运费All in：</span>
                                  <span
                                  v-for="(it,ind) in item.basePriceList"
                                  :key="ind"
                                  class="sumPrice"
                                  >
                                      ${{it.totalPrice}}
                                  </span>
                                  <!-- <span
                                  v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                  :key="ind"
                                  class="sumPrice">
                                  </span> -->
                              </div>
          
                              <div class="base">
                                  <span class="qian_tit qian_tite">Base：</span>
                                  <span
                                  v-for="(it,ind) in item.basePriceList"
                                  :key="ind"
                                  class="sumPrice"
                                  >
                                      ${{it.basePrice}}
                                  </span>
                                  <!-- <span
                                  v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                  :key="ind"
                                  class="sumPrice">
                                  </span> -->
                              </div>
                          </div>
                        </div>
                        <div class="btn">
                            <!-- <el-button  @click="openDrawer(item)">价格明细</el-button>
                            <el-button @click="dingcang(item)">订舱</el-button> -->
                        </div>
                    </div>
                        <div class="zhong">
                            <div>
                                船名航次：{{item.vessel}} / {{item.voyage}}
                            </div>
                            <div class="kuan">
                                运输条款：{{item.transClause}}
                            </div>
                        </div>

                        <div class="xia">
                          <div>
                              运价有效期：{{item.expireStart}} - {{item.expireEnd}}
                          </div>
                        </div>
                    
                </div>
            </div>
          </div>

          <div v-if="total>0 && is_vip==0" class="result noVip" v-loading="loading">
            <!-- 展示 -->
            <!-- 表头 -->
            <div class="table-header">
              <div class="biaotou">
                <div>船公司</div>
                <div class="qi">起运港</div>
                <div class="mu">目的港</div>
                <div
                v-for="(item,index) in boxTitleList"
                :key="index"
                class="gp"
                >
                    {{item}}
                </div>
              </div>
              <div>
                {{gengxinTime}}
              </div>
            </div>
            <div class="table-tbody">
                <div 
                class="neirong"
                v-for="(item,index) in resultsList.slice(0,2)"
                :key="index">
                    <div class="shang">
                      <div class="shang-le">
                        <div class="logo">
                            <img :src="item.shipowner.logo" alt="">
                        </div>
                        <div class="qiyun">
                            <div class="date"><span class="jiacu">ETD:</span>{{item.etd || '--'}}</div>
                            <div class="address">{{qygName}}</div>
                        </div>
                        <div class="dao">
                            <div class="tian">{{item.shipping_date}}天</div>
                            <img src="@/assets/images/Group 113@2x.png" alt="">
                            <div class="zhida">{{item.transitPort.length>0?'中转':'直达'}}</div>
                        </div>
                        <div class="qiyun">
                            <div class="date"><span class="jiacu">ETA:</span>{{item.eta || '--'}}</div>
                            <div class="address">{{mdgName}}</div>
                        </div>
                        <div class="qian">
                            <div>
                                <span class="qian_tit">海运费All in：</span>
                                <span
                                v-for="(it,ind) in item.basePriceList"
                                :key="ind"
                                class="sumPrice"
                                >
                                    ${{it.totalPrice}}
                                </span>
                                <!-- <span
                                v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                :key="ind"
                                class="sumPrice">
                                </span> -->
                            </div>
                        </div>
                            <div class="base">
                                <span class="qian_tit qian_tite">Base：</span>
                                <span
                                v-for="(it,ind) in item.basePriceList"
                                :key="ind"
                                class="sumPrice"
                                >
                                    ${{it.basePrice}}
                                </span>
                                <!-- <span
                                v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                :key="ind"
                                class="sumPrice">
                                </span> -->
                            </div>
                        </div>
                        <div class="btn">
                            <!-- <el-button  @click="openDrawer(item)">价格明细</el-button>
                            <el-button @click="dingcang(item)">订舱</el-button> -->
                        </div>
                    </div>
                        <div class="zhong">
                        <div>
                            船名航次：{{item.vessel}} / {{item.voyage}}
                        </div>
                        <div class="kuan">
                            运输条款：{{item.transClause}}
                        </div>
                    </div>
                    <div class="xia">
                      <div>
                          运价有效期：{{item.expireStart}} - {{item.expireEnd}}
                      </div>
                    </div>
                </div>
                <div 
                class="neirong neirongzhezhao"
                v-for="(item,index) in resultsList.slice(2)"
                :key="index">
                    <div class="shang">
                      <div class="shang-le">
                        <div class="logo">
                            <img :src="item.shipowner.logo" alt="">
                        </div>
                        <div class="qiyun">
                            <div class="date"><span class="jiacu">ETD:</span>{{item.etd || '--'}}</div>
                            <div class="address">{{qygName}}</div>
                        </div>
                        <div class="dao">
                            <div class="tian">{{item.shipping_date}}天</div>
                            <img src="@/assets/images/Group 113@2x.png" alt="">
                            <div class="zhida">{{item.transitPort.length>0?'中转':'直达'}}</div>
                        </div>
                        <div class="qiyun">
                            <div class="date"><span class="jiacu">ETA:</span>{{item.eta || '--'}}</div>
                            <div class="address">{{mdgName}}</div>
                        </div>
                        <div class="qian">
                            <div>
                                <span class="qian_tit">海运费All in：</span>
                                <span
                                v-for="(it,ind) in item.basePriceList"
                                :key="ind"
                                class="sumPrice"
                                >
                                    ${{it.totalPrice}}
                                </span>
                                <!-- <span
                                v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                :key="ind"
                                class="sumPrice">
                                </span> -->
                            </div>
        
                            <div class="base">
                                <span class="qian_tit qian_tite">Base：</span>
                                <span
                                v-for="(it,ind) in item.basePriceList"
                                :key="ind"
                                class="sumPrice"
                                >
                                    ${{it.basePrice}}
                                </span>
                                <!-- <span
                                v-for="(it,ind) in (searchQuery3JXYJ.length-item.basic_freight.length)"
                                :key="ind"
                                class="sumPrice">
                                </span> -->
                            </div>
                        </div>
                      </div>
                        <div class="btn">
                            <!-- <el-button>价格明细</el-button>
                            <el-button>订舱</el-button> -->
                        </div>
                    </div>
                        <div class="zhong">
                        <div>
                            船名航次：{{item.vessel}} / {{item.voyage}}
                        </div>
                        <div class="kuan">
                            运输条款：{{item.transClause}}
                        </div>
                    </div>
                    <div class="xia">
                      <div>
                          运价有效期：{{item.expireStart}} - {{item.expireEnd}}
                      </div>
                    </div>
                </div>                
            </div>

            <div class="noVip-dialog" v-show="noVip">
                <div class="chacha">
                    <i class="el-icon-close" @click="noVip = false"></i>
                </div>
                <div class="novip-tit">
                  非会员用户无法查看更多数据
                </div>
                <div class="noVip-line">
                  <div class="left-line"></div>
                  <div class="word">
                    开通解锁更多特权
                  </div>
                  <div class="left-line"></div>
                </div>
                <div class="noVip-gongneng">
                  <div class="gongnengYi">
                    <div>
                      <img src="@/assets/images/fhy1.png" alt="">
                    </div>
                    <div>
                      查看更多数据
                    </div>
                  </div>
                  <div class="gongnengYi">
                    <div>
                      <img src="@/assets/images/fhy2.png" alt="">
                    </div>
                    <div>
                      使用筛选功能
                    </div>
                  </div>
                  <div class="gongnengYi">
                    <div>
                      <img src="@/assets/images/fhy3.png" alt="">
                    </div>
                    <div>
                      可使用盯舱宝
                    </div>
                  </div>
                </div>
                <div class="noVip-btn">
                  <el-button class="noVip-qy" @click="$router.push('/OpenMembership')">查看会员权益</el-button>
                  <el-button class="noVip-hy" @click="$router.push('/OpenMembership')">开通会员</el-button>
                </div>
              </div>
          </div>
  
          <!-- 分页 -->
          <!-- background="#fff" -->
          <!-- <el-pagination
            v-if="total>0"
            :disabled="is_vip==0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="this.page_no"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination> -->
        </div>
      </div>
  
      <Bottom />

       <!-- 价格明细抽屉 -->
      <!--  -->
      <el-drawer
        title="价格明细"
        :visible.sync="table"
        direction="rtl"
        :with-header="false"
        size="50%">
        <div class="drawer-title">
          <div class="word">
            价格明细<span>实际费用以账单为准</span>
          </div>
          <div>
            <i @click="table = false" class="el-icon-close"></i>
          </div>
        </div>
        <div class="tab-det">
          <div class="tab-tit">基本海运费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>箱型</td>
              <td>价格</td>
            </tr>
            <tr class="tbody"  v-for="(item,ind) in basicList" :key="ind">
              <td  class="first">基本海运费</td>
              <td>{{item.ctnType}}</td>
              <td>{{item.currency}} {{item.totalPrice}}</td>
            </tr>
          </table>

          <!-- <div class="tab-tit">人民币港杂费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>费用类型</td>
              <td colspan="2">费用内容</td>
            </tr>
            <tr class="tbody" v-for="(item,index) in priceList" :key="index">
              <td  class="first">{{item.feeName}}</td>
              <td>{{item.type == 1 ? '按柜收取' : '按票收取' }}</td>
              <td  colspan="2" v-if="item.type == 0">CNY {{item.fee}}</td>
              <td class="xiaotab" v-if="item.type == 1">

                <table  class="table">
                  <tr  class="theader">
                    <td v-for="(value,key,ind) in item.fee" :key="ind">{{key}}</td>
                  </tr>
                  <tr  class="tbody" >
                    <td v-for="(value,key,ind) in item.fee" :key="ind">CNY {{value}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table> -->
        </div>
        <div class="drawer__footer">
          <el-button class="quxiao" @click="table = false">取 消</el-button>
          <el-button class="dingcanggg" @click="table = false">去订舱</el-button>
        </div>
      </el-drawer>
    </div>
  </template>
  
  <script>
  import Bottom from "../HP/BottomPage.vue";
  import TopNavigation from "../HP/TopNavigationB.vue";
  import {
    basePortValidList,
    destinationPortRouteTypeValidList,
    // baseCasesGaugeTypeValidList,
    getSpotrateList,
    baseShippingCompanyValidList,dict,
  } from "@/api/api";
  export default {
    components: {
      Bottom,
      TopNavigation,
    },
    data() {
      return {
        searchQuery1JXYJ: null,
        searchQuery2JXYJ: null,
        searchQuery3JXYJ: [],
        DateValue1: "",
        shipping_company_code:'',
        is_transit:'',
        box_source:'',
        order_field_type:'',
        transportation_terms:'CY-CY',
        qiYGTitleList: [],
        muDgList: [],
        boxTypeList: [
          {
            "id": 17,
            "name": "20GP"
          },
          {
            "id": 18,
            "name": "40GP"
          },
          {
            "id": 19,
            "name": "40HQ"
          },
        ],
        // 筛选
        options: [
          {
            value: "etd",
            label: "开航时间最近",
          },
          {
            value: "tt",
            label: "航程最短",
          },
        ],
        value: "",
        currentPage: 5,
        // 页面跳转带来的参数
        canshu: {},
        //加载
        loading: false,
        headers:{
              token: localStorage.getItem('token')
          },
          // 查询结果：
          resultsList:[],
          // 总条数
          total:0,
          page_no:1,
          page_size:10,
          activeName:'',
          // 默认第一个是开的
        highlightSwitchQY: 1,
        highlightSwitchMD: 1,
        // 起运港参数
        statePortForm:{},
        endPortForm:{},
        // 价格明细抽屉是否打开
        table: false,
        priceList:[],
        basicList:[],
        qygName:'',
        mdgName:'',
        is_vip:JSON.parse(localStorage.getItem('userInfo')).is_vip,
        boxTitleList:[],
        pickerMinDate: null,
        pickerMaxDate: null,
        daySanshi: 30 * 24 * 3600 * 1000,
        pickerOptions: {
            onPick: ({  minDate }) => {
            if (minDate && this.pickerMinDate) {
              this.pickerMinDate = null;
            } else if (minDate) {
              this.pickerMinDate = minDate.getTime();
            }
          },
          disabledDate: (time) => {
            if (this.pickerMinDate) {
              return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7 || (time.getTime() > (this.pickerMinDate + this.daySanshi)) || (time.getTime() < (this.pickerMinDate - this.daySanshi));
            }
            //  return false;
            return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7
          }
        },
        mdgloading:false,
        shippingList:[],
        boxsourceList:[],
        gengxinTime:'',//最近更新时间
        noVip: JSON.parse(localStorage.getItem('userInfo')).is_vip!=0 ? false : true,
        loadingShip:false,
      };
    },
    setup() {},
    methods: {
        openDrawer(e){
          this.table = true
          this.basicList = e.basePriceList
          this.priceList = []
          for (let i = 0; i < e.localChargeList.length; i++) {
            if(e.localChargeList[i].type==1){
              e.localChargeList[i].fee = JSON.parse(JSON.stringify(e.localChargeList[i].fee))
            }
          }
          this.priceList = e.localChargeList
        },
        changeQyg(){
            for (let i = 0; i < this.qiYGTitleList.length; i++) {
               if(this.qiYGTitleList[i].id ==this.searchQuery1JXYJ){
                this.statePortForm = this.qiYGTitleList[i]
                this.qygName = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
               }
            }
        },
        changeMdg(){
            for (let i = 0; i < this.muDgList.length; i++) {
               for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
                for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                  if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2JXYJ){
                    this.endPortForm = this.muDgList[i].tag_arr[j].port_arr[k]
                    this.mdgName = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                  }
                }
               }
            }
        },
      // handleSizeChange(val) {
      //   this.page_size=val
      //   this.searchList()
      // },
      // handleCurrentChange(val) {
      //   this.page_no=val
      //   this.searchList()
      // },
      dingcang(e) {
        let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
          if(is_authentication!=2){
            
            if(is_authentication==0){
              this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                this.$router.push({
                  name:'UserInfo',
                  params:{
                    menuInx: '2'
                  }
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });          
              });
            }else{
              this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                this.$router.push({
                  name:'UserInfo',
                  params:{
                    menuInx: '2'
                  }
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });          
              });
            }

            
            return
          }
        if(this.is_vip==0){
          this.$message({
            type:'error',
          message:'您还不是会员，请先购买会员'
          })
          return
        }
        e.qygName = this.qygName
        e.mdgName = this.mdgName
        sessionStorage.setItem('parameter',JSON.stringify(e))
        this.$router.push({
          name:"ShipSPOTBookingSpace",
        });
      },
      handleChange() {
        this.searchList()
      },
      // 起运港
      async getQygList() {
        // 起运港列表
        let basePortParams = {
          page_no: 1,
          page_size: 50,
          keyword: "",
        };
        const basePortRes = await basePortValidList(basePortParams);
        if (basePortRes.code == 1) {
          this.qiYGTitleList = basePortRes.data.lists;
        }
      },
      // 目的港
      async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.activeName=res.data[0].route_name
          }
          this.mdgloading = false
          // mdgloading:false,
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
      // 箱型
      // async getBoxTypeList() {
      //   // 目的港列表
      //   const res = await baseCasesGaugeTypeValidList();
      //   if (res.code == 1) {
      //     this.boxTypeList = res.data;
      //   }
      // },
      async searchList(){
          this.loading = true
          let order_field = ''
          let order_type = ''
          if(this.order_field_type.length==1){
              order_field=this.order_field_type[0]
          }else if(this.order_field_type.length==2){
              order_field=this.order_field_type[0]
              order_type=this.order_field_type[1]
          }

          let qy = this.highlightSwitchQY == 1 ? 'CY' :'SD'
          let md = this.highlightSwitchMD == 1 ? 'CY' :'SD'

           if(this.DateValue1 == '' || this.DateValue1 == null || this.DateValue1 == undefined){

            this.DateValue1 = []
            var date = new Date();
            var year = date.getFullYear().toString();
            var currentYear = date.getFullYear().toString();
            var month = (date.getMonth() + 1).toString();
            var day = (date.getDate()+2).toString();
            var sanshiyi = ['1','3','5','7','8','10','12']
            var sanshi = ['4','6','9','11']
            var ershiba = '2'

          if(sanshiyi.includes(month)){
            if(month==12){
              if(day>31){
                day = Number(day)-31
                month = Number(month)-11
                year = Number(year)+1
              }
            }
            if(day>31){
              day = Number(day)-31
              month = Number(month)+1
            }
          }else if(sanshi.includes(month)){
            if(day>30){
              day = Number(day)-30
              month = Number(month)+1
            }
          }else if(month==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(day>run){
              day = Number(day)-Number(run)
              month = Number(month)+1
            }
          }
          var currentMonth = String(month);
          var currentDay = String(Number(day)+30);

          if(sanshiyi.includes(currentMonth)){
            if(currentMonth==12){
              if(currentDay>31){
                currentDay = Number(currentDay)-31
                currentMonth = Number(currentMonth)-11
                currentYear = Number(currentYear)+1
              }
            }
            if(currentDay>31){
              currentDay = Number(currentDay)-31
              currentMonth = Number(currentMonth)+1
            }
          }else if(sanshi.includes(currentMonth)){
            if(currentDay>30){
              currentDay = Number(currentDay)-30
              currentMonth = Number(currentMonth)+1
            }
          }else if(currentMonth==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(currentDay>run){
              currentDay = Number(currentDay)-Number(currentDay)
              currentMonth = Number(currentMonth)+1
            }
          }

          // 对月份和日期进行补零
          month = month <10 ? '0' + month : month;
          currentMonth = currentMonth <10 ? '0' + currentMonth : currentMonth;
          day = day < 10 ? '0' + day : day;
          currentDay = currentDay < 10 ? '0' + currentDay : currentDay;
          
          var currentDate = year + '-' + month + '-' + day ;
          var currentDateER = currentYear + '-' + currentMonth + '-' + currentDay;

            this.DateValue1 = [currentDate,currentDateER]
          }
          let form = {
                page_no:this.page_no,
                page_size:this.page_size,
                state_port:this.statePortForm,
                end_port:this.endPortForm,
                cases_gauge_type:this.searchQuery3JXYJ,
                set_sail_start_time:this.DateValue1[0],
                set_sail_end_time:this.DateValue1[1],
                transportation_terms:qy+'-'+md,
                is_transit:this.is_transit,
                shipping_company_code:this.shipping_company_code,
                box_source:this.box_source,
                order_field:order_field,
                order_type:order_type,
          } 
          if(this.searchQuery3JXYJ !=undefined){
            if(this.searchQuery3JXYJ.length>0){
              this.searchQuery3JXYJ=this.searchQuery3JXYJ.sort()
            }
          }
          try {
              const res = await getSpotrateList(form,this.headers)
              if(res.code == 1){
                  this.loading = false
                  this.resultsList = res.data.lists
                  this.total = res.data.lists.length
                  this.gengxinTime = res.data.tis
                  this.boxTitleList = []
                  this.options=[{
                    value: "etd",
                    label: "开航时间最近",
                  },
                  {
                    value: "tt",
                    label: "航程最短",
                  }]

                  for (let i = 0; i < res.data.lists[0].basePriceList.length; i++) {
                    this.boxTitleList.push(res.data.lists[0].basePriceList[i].ctnType)

                    this.options.push({
                      value: res.data.lists[0].basePriceList[i].ctnType,
                      label: res.data.lists[0].basePriceList[i].ctnType,
                      children:[{
                        value: "asc",
                        label: "升序",
                      },
                      {
                        value: "desc",
                        label: "降序",
                      }]
                    })
                  }
              }else{
                this.resultsList = []
                this.total = 0
                this.options=[{
                    value: "etd",
                    label: "开航时间最近",
                  },
                  {
                    value: "tt",
                    label: "航程最短",
                  }]
                  this.gengxinTime = ''

                this.$message({
                  type:'error',
                  message:res.msg
                })
                this.loading = false
              }
          } catch (error) {
            this.loading = false
              console.log(error,'失败');
          }
      },
      handleSwitchQY(val) {
        this.highlightSwitchQY = val;
      },
      handleSwitchMD(val) {
        this.highlightSwitchMD = val;
      },
      // 点击开关--显示样式
      isSwitchQY(val) {
        return this.highlightSwitchQY === val;
      },
      isSwitchMD(val) {
        return this.highlightSwitchMD === val;
      },
      // 获取箱源
      async getXiangYuan(){
        let params = {
          type: 'box_source'
        };
        const res = await dict(params);
        if (res.code==1) {
          this.boxsourceList=res.data.box_source
        }
      },
      // 获取船公司
      async getShip(){
        this.loadingShip = true;
        const res = await baseShippingCompanyValidList();
        if (res.code == 1) {
          this.shippingList = res.data;
        }
        this.loadingShip = false
      },
    },
    mounted() {
      this.canshu = this.$route.params;
      console.log(1111,this.canshu.qi);
      if(this.canshu.qi!=''&& this.canshu.qi!=undefined){
        this.searchQuery1JXYJ=this.canshu.qi
        this.searchQuery2JXYJ=this.canshu.mu
        this.searchQuery3JXYJ=this.canshu.boxtype
        this.qygName=this.canshu.qygName
        this.mdgName=this.canshu.mdgName
        this.statePortForm=this.canshu.statePortForm
        this.endPortForm=this.canshu.endPortForm
        if(this.canshu.createTime !=undefined){
          this.DateValue1 = [this.canshu.createTime,this.canshu.endTime]
        }

        this.searchList()
      }
      // if (this.canshu.transportation_terms != '' || this.canshu.transportation_terms != undefined) {
      //   this.statePortForm=this.canshu.qi
      //   this.end_port=this.canshu.mu
      //   this.searchQuery3JXYJ=this.canshu.boxtype
      //   this.highlightSwitchQY=this.canshu.highlightSwitchQY,
      //   this.highlightSwitchMD=this.canshu.highlightSwitchMD

      //   this.searchQuery1JXYJ = this.canshu.qi.id
      //   this.searchQuery2JXYJ = this.canshu.mu.port_id
      //   if(this.canshu.createTime!=undefined){
      //     this.DateValue1=[this.canshu.createTime,this.canshu.endTime]
      //   }

      //   this.searchList()
      // }
      this.getQygList();
      this.getMdgList();
      // this.getBoxTypeList();
      this.getXiangYuan()
      this.getShip()
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .topNavigation {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
  }
  
  .searchResult {
    background: #f9f9f9;
  }
  
  .typeArea {
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    margin-bottom: 32px;
  }
  
  .el-breadcrumb {
    margin: 20px 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .el-breadcrumb__inner is-link {
      color: pink;
    }
  }
  
  :deep(.el-breadcrumb) {
    .el-breadcrumb__inner {
      color: #999999 !important;
    }
    .bread {
      span {
        color: #0073f5 !important;
      }
    }
  }
  
  .conditiobn {
    // width: 1200px;
    box-sizing: border-box;
    height: 269px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    padding: 24px;
  
    :deep(.el-select) {
      input {
        background: #f9f9f9;
        border: 0;
        padding: 0;
      }
    }
  
    .title {
      display: flex;
      align-items: center;
      span {
        height: 28px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
  
      img {
        width: 42px;
        margin: 0 12px;
      }
    }
  }
  
  .line {
    width: 100%;
    height: 1px;
    background: #eee;
    margin: 24px 0;
  }
  
  .condition {
    display: flex;
    align-items: center;
  
    :deep(.el-select) {
      input {
        background: #f9f9f9;
        border: 0;
        padding: 15px;
      }
    }
    .img {
      width: 24px;
      height: 24px;
    }
    .span {
      // width: 32px;
      // height: 22px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 8px;
      margin-right: 20px;
    }
    .el-select,
    .el-cascader {
      margin-right: 12px;
    }
  
    :deep(.el-input__inner) {
      width: 240px;
      height: 48px;
      background: #f9f9f9;
      border: 0;
    }
  }
  
  .result {
    // width: 1200px;
    // height: 1662px;
    background: #fff;
    border-radius: 12px 12px 12px 12px;
    margin-top: 20px;
    margin-bottom: 24px;
    // padding: 24px;
  
    .table-header {
      display: flex;
      justify-content: space-between;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding: 24px;
  
      border-bottom: #eee 1px solid;

      .biaotou{
        display: flex;
      }
      .qi {
        margin-left: 48px;
        margin-right: 218px;
      }
  
      .mu{
        margin-right: 228px;
      }
      .gp {
        margin-right: 50px;
      }
      .hq {
        margin-left: 0px;
      }

      .kucun{
            margin-right: 150px;
        }
    }
  
    .table-tbody{
      .neirongzhezhao{
        position: relative;
        filter: blur(4px);
        user-select: none;
      }

        .neirong{
            padding:  24px 0;
            margin:0 24px ;
            border-bottom: #eee 1px solid;
        }

        .neirong:last-child{
            border: 0;
        }
        .shang{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .shang-le{
              display: flex;
              align-items: center;
            }
            .logo{
                width: 40px;
                margin-right: 50px;
                img{
                  width: 65px;
                }
            }
            .qiyun{
                width: 130px;
                margin-right: 20px;
                .date{
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    margin-bottom: 4px;

                    .jiacu{
                      font-weight: bold;
                    }
                }
                .address{
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #606266;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    overflow:hidden; 
                    text-overflow:ellipsis; 
                    white-space:nowrap;
                }
            }

            
            .dao{
                width: 100px;
                text-align: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #606266;
                font-style: normal;
                text-transform: none;

                margin: 0 10px;
                img{
                    width: 100px;
                    height: 7px;
                }
                div{
                    height: 12px;
                }
            }

            .keshou{
                width: 32px;
                font-size: 14px;
                color: #0073F5;
                margin-left: 32px;
                margin-right: 46px;
            }
            .bukeshou{
                width: 45px;
                color: #606266;
                margin-right: 32px;
            }

            .qian{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                span:first-child{
                    color: #606266;
                    // margin-right: 10px;
                }
                span:nth-child(3){
                    margin: 0 34px;
                }
                span{
                    color: #FE3300;
                }

                .qian_tit{
                    width: 100px;
                    text-align: right;
                    display: inline-block;
                    margin-right: 6px;
                }

                .base{
                    margin-top: 6px;
                }
            }

            .btn{
                // margin-left: 33px;
                display: flex;
                .el-button:first-child{
                    width: 88px;
                    height: 40px;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #0073F5;
                    text-align: center;
                    color: #0073F5;
                    background: #fff;
                    display: flex;
                    justify-content: center;
                }
                .el-button:last-child{
                    width: 88px;
                    height: 40px;
                    background: #0073F5;
                    border-radius: 8px 8px 8px 8px;
                    color: #fff;
                    border: 0;
                }

                .bukeding{
                    background: #0073F5;
                    opacity: 0.4;
                }
            }
        }

        .zhong{
            display: flex;

            margin-top: 16px;
            margin-bottom: 12px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606266;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            div{
                margin-right: 48px;
            }
            .kuan{
                width: 130px;
            }
        }

        .xia{
            display: flex;

            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #606266;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            .kuan{
                width: 130px;
                margin-right: 48px;

                display: flex;
            }

            .kuan:nth-child(2){
                width: 132px;
                margin-right: 42px;
            }
            .cilick{
                cursor: pointer;
                color: #0073F5;
            }
        }
    }
  }
  
  .el-popover {
    p {
      color: #999;
    }
    span {
      color: #fe3300;
    }
  }
  
  :deep(.el-pagination) {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-end;
    button,
    li {
      background: #fff !important;
    }
    li.active {
      background-color: #409eff !important;
      color: #fff;
    }
  }
  .delivery-main {
    // width: 1152px;
    // height: 72px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 14px 8px 14px 16px;
    display: flex;
    justify-content: space-between;
    .delivery-main-box {
      border-right: 1px solid #ddd;
      padding-right: 8px;
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:nth-child(-n + 2) {
        width: 300px;
      }
      &:nth-child(n + 2) {
        margin-left: 8px;
      }
      &:nth-child(3) {
        width: 200px;
        input {
          width: 130px;
        }
      }
      &:nth-child(4) {
        border: 0;
        width: 220px;
      }
      .dateSpan {
        margin-right: 12px;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      .address {
        width: 304px;
        // div:first-child{
        //   color: #666;
        // }
        div {
          display: block;
          height: 20px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          background: #f9f9f9;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        input {
          color: #333;
          margin-top: 4px;
        }
        input::placeholder {
          color: #ccc;
        }
        .el-icon-date:before {
          content: "";
        }
        .el-input {
          display: inline-block;
          width: 80px;
        }
        .el-input--prefix .el-input__inner {
          padding-left: 0;
          padding-right: 0;
          width: 80px;
          height: 20px;
          font-size: 14px;
          display: inline-block;
        }
      }
  
      // 选择开关
      .switch {
        width: 100px;
        height: 34px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        padding: 4px;
        display: flex;
        div {
          // width: 43px;
          height: 100%;
          border-radius: 8px 8px 8px 8px;
          color: #999999;
          padding: 3px 7px;
          font-size: 14px;
          box-sizing: border-box;
          &:nth-child(1) {
            margin-right: 4px;
          }
        }
        .switchBackground {
          background: #0073f5;
          color: #ffffff;
        }
      }
    }
    .search {
      width: 52px;
      height: 52px;
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: #fff;
        font-size: 20px;
      }
    }
  
    // 日期选择器
    :deep(.el-date-editor) {
      width: 200px !important;
      border: 0px;
      background: #f9f9f9;
      padding: 0;
      display: flex !important;
      align-items: baseline;
      height: 20px;
      input {
        background: #f9f9f9;
      }
      i.el-input__icon.el-range__icon.null {
        width: 0px;
      }
      .el-date-editor .el-range-separator {
        height: 20px;
      }
    }
  }
  .delivery-main-1 {
    flex-wrap: wrap;
    padding-bottom: 0;
    .delivery-main-box {
      margin-bottom: 16px;
      &:nth-child(n + 1) {
        width: 360px;
      }
      // &:nth-child(n + 2) {
      //   margin-left: 8px;
      // }
      &:nth-child(3n) {
        border: 0;
      }
      &:nth-child(4) {
        border-right: 1px solid #ddd;
        margin-left: 0px;
      }
    }
  }
  
  .youjiantou {
    position: relative;
    .youbian {
      position: absolute;
      // left: 316px;
      top: 18px;
      right: -18px;
    }
    .youbianvv {
      top: 13px;
    }
  }
  
  .jiantou {
    margin-right: 10px;
  }
  
  .el-dropdown {
    position: relative;
    span {
      position: absolute;
      top: -5px;
      right: 20px;
    }
  }

  
  .mudig {
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
    width: 500px;
    .mdglist {
      :deep(.el-select-group) {
        display: flex;
        flex-wrap: wrap;
      }
    }
    :deep(.el-select) {
      ul.el-select-group {
        display: flex;
      }
    }
  }
  
  .xiangxing {
    :deep(.el-select__tags) {
      margin-top: 10px;
      span.el-tag.el-tag--info.el-tag--small.el-tag--light {
        margin: 2px 6px 2px 0;
      }
    }
  }
  
  .sumPrice{
      display: inline-block;
      width: 50px;
  }
  .switch {
        width: 100px;
        height: 34px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        padding: 4px;
        display: flex;
        div {
            cursor: pointer;
          // width: 43px;
          height: 100%;
          border-radius: 8px 8px 8px 8px;
          color: #999999;
          padding: 3px 7px;
          font-size: 14px;
          box-sizing: border-box;
          &:nth-child(1) {
            margin-right: 4px;
          }
        }
        .switchBackground {
          background: #0073f5;
          color: #ffffff;
        }
      }

.el-drawer{
  .drawer-title{
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span{
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i{
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det{
    padding: 32px 32px 0 32px;
  }

  .tab-tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }
 

  .drawer__footer{
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao{
      width: 100px;
      height: 40px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg{
      width: 100px;
      height: 40px;
      background: #0073F5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}
.table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    td{
      padding-left: 12px;
    }
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

    }
}

.datab{
  margin-top: 20px;
  border: solid 1px #eee;

  .xiaotab{
    padding: 0;
  }
}

.noVip{
    position: relative;
  }
  .noVip-dialog{
    position: absolute;
    // top: 438px;
    top: 38px;
    left: 50%;
    transform: translate(-50%, 0);
    
    width: 448px;
    height: 306px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.08);
    border-radius: 16px 16px 16px 16px;
    text-align: center;
    .chacha{
      text-align: right;
      
      .el-icon-close{
        padding: 12px;
        width: 20px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .novip-tit{
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      margin-bottom: 24px;
      // margin-top: 32px;
    }

    .noVip-line{
      display: flex;
      justify-content: center;
      align-items: center;
      .left-line{
        width: 128px;
        height: 1px;
        background: #0073F5;
      }

      .word{
        font-weight: 500;
        font-size: 16px;
        color: #0073F5;
        margin: 0 8px;
      }
    }

    .noVip-gongneng{
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
      margin-bottom: 32px;
      .gongnengYi{
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        img{
          width: 40px;
          height: 40px;
        }
      }
    }

    .noVip-btn{
      .noVip-qy{
        width: 200px;
        height: 48px;
        background: #EEEEEE;
        border-radius: 24px 24px 24px 24px;
        font-weight: 500;
        font-size: 16px;
        color: #666666;
        border: 0;
      }
      .noVip-hy{
        width: 200px;
        height: 48px;
        background: #0073F5;
        border-radius: 24px 24px 24px 24px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }
  </style>